import * as React from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { Spinner } from './Spinner';
import { Theme } from '../models/Theme';

const FundCardLoading = styled<any, any>('div', 'fundCardLoading', 'loading')`
    ${propStyles};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
`;

FundCardLoading.defaultProps = {
    bgColor: 'rgba(255, 255, 255, 0.8)',
    // zIndex: 'popover',
};

interface LoadingProps {
    theme?: Theme;
}

class Loading extends React.Component<LoadingProps> {
    render() {
        const { theme } = this.props;
        return (
            <FundCardLoading {...theme.FundCardLoading}>
                <Spinner
                    color="primary"
                    iconSize="lg"
                    {...theme.LoadingSpinner}
                />
            </FundCardLoading>
        );
    }
}

export default observer(withTheme(Loading)) as any;



// WEBPACK FOOTER //
// ./src/Components/Loading.tsx